// Copyright (C) 2021-Present CITEC Inc. <https://citecsolutions.com/>
// All rights reserved
//
// This file is part of CITEC Inc. source code.
// This software framework contains the confidential and proprietary information
// of CITEC Inc., its affiliates, and its licensors. Your use of these
// materials is governed by the terms of the Agreement between your organization
// and CITEC Inc., and any unauthorized use is forbidden. Except as otherwise
// stated in the Agreement, this software framework is for your internal use
// only and may only be shared outside your organization with the prior written
// permission of CITEC Inc.
// CITEC Inc. source code can not be copied and/or distributed without the express
// permission of CITEC Inc.

import { Button, CircularProgress, ListItem } from '@mui/material';
import { AppIcon } from '@shared/ui-kit/components';
import { Translation } from '@shared/ui-kit/providers/translation-provider/translation';
import { classNames } from '@shared/ui-kit/utils/classnames';
import { defineComponent } from '@shared/ui-kit/utils/define-component';
import styles from './bank-details-drawer-footer.module.css';
import { useBankDetailsDrawerFooter } from './use-bank-details-drawer-footer';

export const BankDetailsDrawerFooter = defineComponent({
  displayName: 'BankDetailsDrawerFooter',
  useSetup: useBankDetailsDrawerFooter,
  View: ({
    onClose,
    onDelete,
    onSave,
    isSaveDisabled,
    isSaveLoading,
    showDelete,
    showSave,
    showClose,
  }) => (
    <ListItem
      component="div"
      className={classNames(styles.section, styles['section-sticky-bottom'])}
      disablePadding
      disableGutters
      data-testid="bank-details-drawer-footer"
    >
      <div className={styles['footer-actions']}>
        {showSave ? (
          <Button
            type="button"
            color="secondary"
            fullWidth
            onClick={onSave}
            disabled={isSaveDisabled || isSaveLoading}
            endIcon={
              isSaveLoading ? (
                <CircularProgress size={16} color="secondary" />
              ) : (
                <AppIcon icon="ArrowRight" color="inherit" size="lg" />
              )
            }
            data-testid="bank-details-drawer-save"
          >
            {isSaveLoading ? (
              <Translation i18nKey="common.saving" ns="common" />
            ) : (
              <Translation i18nKey="common.save-changes" ns="common" />
            )}
          </Button>
        ) : null}

        {showDelete ? (
          <Button
            type="button"
            variant="text"
            color="error"
            fullWidth
            onClick={onDelete}
            startIcon={<AppIcon icon="Trashcan" color="inherit" size="lg" />}
            data-testid="bank-details-drawer-disconnect"
          >
            <Translation i18nKey="aggregator.disconnect-account" ns="aggregator" />
          </Button>
        ) : null}

        {showClose ? (
          <Button
            type="button"
            variant="outlined"
            color="secondary"
            fullWidth
            onClick={onClose}
            data-testid="bank-details-drawer-close"
          >
            <Translation i18nKey="common.close" ns="common" />
          </Button>
        ) : null}
      </div>
    </ListItem>
  ),
});
